import React from 'react'
import { Formik, Field } from 'formik'
import { Form } from 'lib/ui/components'
import { useHistory, useParams } from 'react-router-dom'
import { useBlogToolbar } from 'hooks/blog'
import { ALL_POSTS_CATEGORY } from 'app/sofia/resources/constants'
import { ReactComponent as SearchSvg } from 'resources/svg/icons/search.svg'
import { Wrapper } from './styled'
import { SidebarBlocks } from '../SidebarBlocks'

interface Tag {
  name: string
  url_key: string
  id: number
}

interface Option {
  label: string
  value: string
}

interface Props {
  isTag?: boolean
}
export const Toolbar = ({ isTag = false }: Props) => {
  const params = useParams<{ slug: string }>()
  const slug = params.slug
  const { tagList, search, sortBy } = useBlogToolbar(ALL_POSTS_CATEGORY)
  const history = useHistory()

  const handleTagChange = ({ target }: React.ChangeEvent<HTMLSelectElement>) => {
    history.push(`/blog/tag/${target.value}`)
  }

  const handleSortChange = ({ target }: React.ChangeEvent<HTMLSelectElement>) => {
    sortBy(target?.value)
  }

  const handleSearch = ({ search: searchString }: any) => {
    search(searchString)
  }

  const initialValues = {
    search: ''
  }

  return (
    <Wrapper>
      <div className='search'>
        <Formik
          initialValues={initialValues}
          onSubmit={handleSearch}
        >
          <Form.Wrapper>
            <label>Search Posts by Keyword:</label>
            <div className='field'>
              <Field
                name='search'
                component={Form.Input}
              />
              <button onClick={handleSearch} type='button'>
                <SearchSvg />
              </button>
            </div>
          </Form.Wrapper>
        </Formik>
      </div>
      <div>
        <label>Sort Posts by:</label>
        <select
          onChange={handleSortChange}
        >
          {sortOptions?.map((option: Option) => (
            <option key={option.value} value={option.value}>{option.label}</option>
          ))}
        </select>
      </div>
      <div>
        {tagList && (
          <>
            <label>
              Filter Posts by Topic:
            </label>
            <select
              value={slug}
              onChange={handleTagChange}
            >
              <option value='' />
              {tagList?.map((option: Tag) => (
                <option key={option.id} value={option.url_key}>{option.name}</option>
              ))}
            </select>
          </>
        )}
      </div>
      <SidebarBlocks slug={slug} />
    </Wrapper>
  )
}

const sortOptions = [
  {
    label: 'Most Recent posts',
    value: 'most_recent-DESC'
  },
  {
    label: 'Oldest posts',
    value: 'most_recent-ASC'
  },
  {
    label: 'Name Z-A',
    value: 'name-DESC '
  },
  {
    label: 'Name A-Z',
    value: 'name-ASC'
  }
]
